import { render, staticRenderFns } from "./ORegisterInfoEdit.vue?vue&type=template&id=990f5f90&scoped=true&"
import script from "./ORegisterInfoEdit.vue?vue&type=script&lang=ts&"
export * from "./ORegisterInfoEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ORegisterInfoEdit.vue?vue&type=style&index=0&id=990f5f90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990f5f90",
  null
  
)

export default component.exports